import ApiService from './service';
import * as http from './http';

export class SearchFlipHubService extends ApiService {
    async addDetails(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.post(url, data, this.store);
    }
}
